import i from "../../locales/en-US/index.js";
import r from "../../locales/pt-BR/index.js";
const n = {
  "en-US": (t) => i[t],
  "pt-BR": (t) => r[t]
}, p = (t, o) => t && n[t] ? n[t](o) : r[o];
export {
  p as getLocaleFile,
  n as translationFiles
};
